import { getStartFormDataQuery, getTaskFormDataQuery } from "../api/task-api";
import { applyExcludeOutcomes } from "./filter-outcome";
import { queryClient } from "../../../../index";

export const loadStartForm = async (
  processDefinitionKey: string,
  excludeOutcomes: string[] | null,
) => {
  const raw = await queryClient.fetchQuery(
    getStartFormDataQuery(processDefinitionKey),
  );
  return applyExcludeOutcomes(raw, excludeOutcomes);
};

export const loadTaskForm = async (
  taskId: string,
  excludeOutcomes: string[] | null,
) => {
  const raw = await queryClient.fetchQuery(getTaskFormDataQuery(taskId));
  return applyExcludeOutcomes(raw, excludeOutcomes);
};
